<template lang="pug">
  #app
    router-view(:key="$route.fullPath.split('/').slice(0, 3).join('/')")
    error-handler
</template>

<script>
import ErrorHandler from '@/components/ErrorHandler.vue';

export default {
  components: {
    ErrorHandler,
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');
  @import './directives/rc-loader/rcLoader.css';
  @import './styles/checkbox.scss';
  @import './styles/radio-button.scss';
  html { font-family: 'Inter', sans-serif; }
  @supports (font-variation-settings: normal) {
    html { font-family: 'Inter var', sans-serif; }
  }
  input, button, select { font-family: 'Inter', sans-serif; }
  button {
    font-size: 14px;
    color: white;
    background-color: var(--primary);
    border: 1px solid #707070;
    border-radius: .5em;
    padding: .5em 1em;
    cursor: pointer;
  }
  html {
    --primary: #025A94;
    body {
      margin: 0;
    }
  }
  .responsive-table {
    padding-left: 0;
    margin: 0;
    font-size: 16px;
    .item-container {
      display: grid;
      align-items: center;
      &:not(:first-of-type) {
        border-top: 1px solid #dedede;
      }
      > .attribute-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(var(--column-width-min), 1fr));
        align-items: center;
        padding: 0 1em;
      }
      > .attribute {
        display: flex;
        justify-content: center;
        text-align: center;
        padding: 0 1em;
      }
      .attribute.justify-left {
        align-items: center;
        display: flex;
        justify-content: flex-start;
        text-align: left;
      }
    }
    .no-results {
      display: flex;
      height: 20em;
      align-items: center;
      justify-content: center;
      font-style: italic;
      color: #6A6A6A;
    }
  }
</style>